'use client';

import { JoyrideTour } from './JoyrideTour';
import { profileTourSteps } from './profileTourSteps';

/**
 * Per-feature tour for an advocate profile: auto-launches once
 * (localStorage-backed under `tour:seen:profile`), then never again.
 *
 * Visibility is gated centrally in `JoyrideTour` (logged-in users only), so
 * this wrapper carries no per-feature conditions of its own.
 */
export function ProfileTour() {
  return <JoyrideTour name='profile' steps={profileTourSteps} auto />;
}
